<template>
  <article :class="wrapClass">
    <div class="cursor cursor--small"></div>
    <canvas class="cursor cursor--canvas" resize></canvas>
    <Header :trigger="trigger"/>
    <div class="container about">
      <section class="about__intro">
        <h1>about us</h1>
        <p class="about__intro__label">the team</p>
        <p class="about__intro__intro">we’ve have desperately collected the dream team. we think that design and development goes hand in hand.</p>
        <p class="about__intro__label">service</p>
        <p class="about__text">Desperate. is a full service design and development agency, that helps companies with their identity and optimization of their current problems. <br>We help our clients to improve their visual touch, the infrastructure and communication between development and design. <br><br></p>
        <p class="about__intro__label">location</p>
        <p class="about__text">Either we sit on the clients location or work from the office, the best practice is that development and design sit together. Therefore it’s important to include both worlds to get the best result.</p>
      </section>
      <img :src="blob" class="about__blob">
      <section class="about__split">
        <h1>What we do</h1>
        <div>
          <img :src="development" class="about__split__label">
          <h2>development & hosting</h2>
          <p>we can deliver code to other developers or make the full service of creating everything on our own. The team can create everything codewise from frontend development over motion design to cms and backend development.<br><br>we further offer price competitive hosting solutions, based on state of the art server hardware.</p>
        </div>
        <div>
          <img :src="design" class="about__split__label">
          <h2>design & creative thinking</h2>
          <p>do you want a new identity? Optimizing the visual look and feel? Or a design system for the company? We have experience with all of those and know how to create and implement a better structure.</p>
        </div>
        <div>
          <img :src="workshop" class="about__split__label">
          <h2>workshop facilitation</h2>
          <p>a method to come closer to a great result, is to ideate on the problems. We can help with workshops to come closer to what the issue is about. No matter if you're a startup or already settled company, we have the tools necessary to ensure your digital development!</p>
        </div>
        <div>
          <img :src="motion" class="about__split__label">
          <h2>motion design & prototyping</h2>
          <p>we believe that motion design is the body language of the web. Therefore it’s important to have the right way of presenting the content. No space for unnecessary animations, but rather playful interactions make your visitors more aware of your identity!</p>
        </div>
      </section>
      <section class="about__split">
        <h1>insight and services</h1>
        <div>
          <img :src="right" class="about__split__label">
          <h2>the right language</h2>
          <p>design systems helps eliminating inconsistency in terms of communications for the design and code team. less maintenance is needed for the project and both time and money are saved. the process is also speeded up, because elements are created and ready to be implemented.<br><br>by creating a clear experience for the customers, their journey are made easier. heavy cognitive load will occur if there’s no consistency created when switching from mobile experience to desktop experience.<br><br>imagine if you were looking at your google gmail on your phone, and after a couple minutes, checked it on your browser. If they look and behave differently you’d probably be a little confused and maybe even a little frustrated of the experience.</p>
        </div>
        <div>
          <img :src="delivery" class="about__split__label">
          <h2>startup minds</h2>
          <p>at desperate, we have years of experience helping startups through events and development. as such, we know how the startup comminuty works and what is needed in the different stages of development. <br><br>grab hold os us today, and we'll help your startup thrive, through packages specified for startup needs</p>
        </div>
      </section>
      <Footer />
    </div>
  </article>
</template>

<script>
import Header from '@/components/Header/Header';
import IntroBox from '@/components/IntroBox/IntroBox';
import Footer from '@/components/Footer/Footer';
import './style.scss';
import blob from '@/assets/about-blob.png';
import development from '@/assets/development.png';
import design from '@/assets/design.png';
import workshop from '@/assets/workshop.png';
import motion from '@/assets/motion.png';
import right from '@/assets/right.png';
import delivery from '@/assets/delivery.png';
import mouse from '@/utils/mouse';
import ismobile from '@/utils/ismobile';

export default {
  name: 'About',
  data() {
    return {
      wrapClass: 'wrap wrap--bottom-left',
      blob,
      development,
      design,
      workshop,
      motion,
      right,
      delivery,
    };
  },
  components: {
    Header,
    IntroBox,
    Footer,
  },
  mounted() {
    !ismobile() && mouse();
    setTimeout(() => {
      this.wrapClass = 'wrap wrap--bottom-left loaded';
    }, 400);

  },
  methods: {
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/containers/About/About.vue